import { Input } from 'component/Input'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'

export const NameInput = observer(() => {
  const store = userModal.it
  const { name, busy } = store
  const label = i18n('Name')

  const onChange = useLatestCallback((value: string) => {
    store.name = value || ''
  })

  return <Vertical gap={8}>
    <Typo size={11} medium upper>
      {label}
    </Typo>
    <Input upper height={48} value={name} onChange={onChange}
      disabled={busy} placeholder={label} />
  </Vertical>
})
